export default __webpack_public_path__ + "static/media/image.60298abc.svg";